<template>
  <div class="home">
    <the-home-carousel/>

    <div class="popular-coin">
      <h3>داغ ترین ارز های دیجیتال</h3>
      <the-popular-coin :key="' '+ $store.state.usd.length" />
    </div>

    <the-market-table />
    <the-support-coins-text/>
    <the-services/>
    <the-about-home-section/>
    <the-user-info/>
    <the-app-section/>
  </div>
</template>

<script>

import TheHomeCarousel from "./the-home-carousel";
import ThePopularCoin from "./the-popular-coin";
import TheMarketTable from "../market/the-market-table";
import TheSupportCoinsText from "./the-support-coins-text";
import TheAboutHomeSection from "./the-about-home-section";
import TheUserInfo from "./the-user-info";
import TheServices from "./the-services";
import TheAppSection from "./the-app-section";

export default {
  name: 'Home',
  components: {
    TheAppSection,
    TheServices,
    TheUserInfo,
    TheAboutHomeSection,
    TheSupportCoinsText,
    TheMarketTable,
    ThePopularCoin,
    TheHomeCarousel

  },
  data() {
    return {
      content:[],
      type:null,
      tempType:null,
    }
  },
  watch:{
    'content'(){
      this.state.loading=false;
    }
  },
  methods: {
//     getData(value){
//       // console.log(value)
//       this.content=value;
//     },
//     async setData(){
// // this.state.loading = true;
//
//
//
//       const content = await this.$socket()
// // console.log(this.$store.state.type)
//       const type = this.$store.state.type;
//       await content.on(type=='toman'?'USD':'USDT',function(data){
// // console.log(data)
//             const parsed =  JSON.parse(data)
//              this.getData(parsed)
//
//           }.bind(this)
//       )
//
//     },
//     getValue(value){
//       this.type = value
//       this.tempType = this.type
// // console.log(this.tempType)
//     }

    },



    mounted() {


     // console.log('toman:', this.$store.state.type)


  }
}
</script>

<style lang="scss">
.home{
  display: flex;
  flex-direction: column;
  background-image: url("../../assets/Home/BACKGROUND0.png");
  background-size: cover;
  background-position: center;
  gap: 2em;
}
.popular-coin{
  height: 263px;
  text-align: right;
  margin-bottom: 125px;

  h3{
    color: #FBFBFD;
    right: 10%;
    position: relative;
    margin-top: 100px;
  }
}
</style>